export const SUPPORTS_ARRAY_PROTOTYPE_MAP = "map" in Array.prototype;
